var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-pt-xl"},[_c('Attachments',{attrs:{"parentObj":_vm.parentObj,"parentType":'farm'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }